import SimilarityPage, {
  similarityQuery,
} from "@app/pages/rules/similarity-page";
import type { similarityPage_Query } from "@app/queries/similarityPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/rules_/similar")({
  loader: () =>
    loadQuery<similarityPage_Query>(
      environment,
      similarityQuery,
      {},
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Similar rules"),
  component: SimilarityRoute,
});

function SimilarityRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading similar rules</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading similar rules...</div>
        }
      >
        <SimilarityPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
